import { EmptyState } from "@fluidattacks/design";
import { useTranslation } from "react-i18next";

import type { IMatchesEmptyStateProps } from "./types";

const MatchesEmptyState: React.FC<IMatchesEmptyStateProps> = ({
  onClick,
}: IMatchesEmptyStateProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <EmptyState
      confirmButton={{
        onClick,
        text: t("group.matches.emptyState.addButton"),
      }}
      description={t("group.matches.emptyState.description")}
      imageSrc={"integrates/empty/uploadIcon"}
      title={t("group.matches.emptyState.title")}
    />
  );
};

export { MatchesEmptyState };
